import { SaveOutlined } from '@ant-design/icons'
import { Col, InputNumber, Row } from 'antd'
import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { GLOBAL_CLIENT } from 'src/helpers/GlobalClient'
import { ROLE, STATUS_JOB, isJobManagerRole } from 'src/helpers/constants'
import { showMessageError, showMessageSuccess } from 'src/helpers/functions'
import { useStore } from 'src/hooks'

/**
 * Khoi "Tong so mui theu" (so nguyen) + "So mui theu moi" (so) trong popup chi tiet viec.
 * Moi role deu thay; designer cua viec (tru viec da huy) va admin/supporter sua duoc,
 * luu bang API /job/stitches. De trong = chua nhap (null).
 */
const JobDetailStitches = observer(() => {
   const { t } = useTranslation()
   const JobDetailStore = useStore('JobDetailStore')
   const JobsStore = useStore('JobsStore')
   const AuthStore = useStore('AuthStore')
   const { jobDetail } = JobDetailStore
   const role = AuthStore.data_role
   const [isSaving, setIsSaving] = useState(false)
   const isDirty = JobDetailStore.isFieldDirty('totalStitches', 'newStitches')

   const isOwnDesigner =
      role === ROLE.DESIGNER &&
      !!jobDetail?.designerId &&
      String(jobDetail.designerId) === String(AuthStore.data_getUserInfo?.id) &&
      jobDetail?.status !== STATUS_JOB.CANCEL
   const canEdit = isJobManagerRole(role) || isOwnDesigner

   const handleChange = (field: 'totalStitches' | 'newStitches') => (value: number | string | null | undefined) => {
      JobDetailStore.markFieldDirty(field)
      JobDetailStore.setJobDetailStitches({ [field]: value === '' || value == null ? null : Number(value) })
   }

   const handleSave = async () => {
      const totalStitches = jobDetail?.totalStitches ?? null
      const newStitches = jobDetail?.newStitches ?? null
      try {
         setIsSaving(true)
         const response = await JobDetailStore.updateStitches(jobDetail?.id, { totalStitches, newStitches })
         if (!response) return
         // Va lai dong tuong ung ngoai bang quan ly viec de khong phai tai lai trang
         JobsStore.action_patchJobRow(jobDetail?.id, { totalStitches, newStitches })
         showMessageSuccess('Đã cập nhật')
      } catch (error) {
         showMessageError(error)
      } finally {
         setIsSaving(false)
      }
   }

   const inputStyle = {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '22px',
      color: '#5C5C5C',
      border: 'solid 1px #dadada'
   }

   const readOnlyStyle = {
      ...inputStyle,
      padding: '9px 11px',
      borderRadius: 6,
      minHeight: 42
   }

   const renderField = (field: 'totalStitches' | 'newStitches', placeholder: string, isInteger: boolean) => {
      const value = jobDetail?.[field]
      if (!canEdit) {
         return <div style={readOnlyStyle}>{value ?? '-'}</div>
      }
      return (
         <InputNumber
            value={value ?? undefined}
            onChange={handleChange(field)}
            placeholder={placeholder}
            min={0}
            precision={isInteger ? 0 : undefined}
            style={{ ...inputStyle, width: '100%', paddingTop: 4, paddingBottom: 4 }}
         />
      )
   }

   return (
      <>
         <Row className="gx-flex-row gx-align-items-center gx-justify-content-between gx-mx-1" wrap={false}>
            <h4 style={{ fontSize: 14, fontWeight: 600, lineHeight: '22px', color: '#272944' }}>
               {`${t(GLOBAL_CLIENT.totalStitches)} / ${t(GLOBAL_CLIENT.newStitches)}`}
            </h4>
            {canEdit && isDirty && (
               <div className="gx-module-logo gx-mb-2" onClick={isSaving ? undefined : handleSave}>
                  <SaveOutlined style={{ color: '#272944', marginLeft: 8 }} />
                  <div style={{ fontSize: 14, fontWeight: 400, lineHeight: '22px', color: '#272944', marginLeft: 8 }}>
                     {t(GLOBAL_CLIENT.save)}
                  </div>
               </div>
            )}
         </Row>
         <Row className="gx-flex-row gx-align-items-center gx-mb-2 gx-mx-1" gutter={8}>
            <Col xs={24} md={12} className="gx-mb-2">
               {renderField('totalStitches', t(GLOBAL_CLIENT.nhaptotalstitches), true)}
            </Col>
            <Col xs={24} md={12} className="gx-mb-2">
               {renderField('newStitches', t(GLOBAL_CLIENT.nhapnewstitches), false)}
            </Col>
         </Row>
      </>
   )
})

export default JobDetailStitches
